/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
    <style include="app-styles">
      paper-card {
        height: fit-content !important;
        padding:24px 10% 10%;
      }
      paper-checkbox .selection-checkbox {
        --paper-checkbox-label-spacing: 0;
        --paper-checkbox-checked-color: #3CB371;
      }
      .list-search{
        padding: 0 0px 20px 0px;
      }
      .listing-filter-actions {
        padding: 0px 24px 24px;
      }
      .font-style {
        letter-spacing: 0.0025em;
      }
      .heading-sub-font {
        padding: 0px 24px 24px;
      }
      .font-color{
        color: rgb(0, 131, 155);
      }
      .decline-text {
        font-size: 16px;
        font-weight: 700;
        color: #101214;
      }
    </style>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <div class="content-align-center">
      <div class="margin-b-zero mdl-cell mdl-cell--10-col">
        <paper-card>
          <h1 class="credit-heading">
            <disclaimer-component info-msg = {{infoMsgVatAmount}}></disclaimer-component>
          </h1>
          <h1 class="credit-heading">
            <disclaimer-component info-msg = {{infoMsgExchangeRate}}></disclaimer-component>
          </h1>
          <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
            <div class="mdl-cell mdl-cell--12-col" style="padding-bottom: 10px"> 
                <div class="font-style font-30">
                    <oe-i18n-msg msgid="l_prereqdetails" role="heading" aria-level="1"></oe-i18n-msg>
                </div>
            </div>
            <div class="mdl-cell mdl-cell--12-col">
                <div class="font-style font-16 font-color">
                    <oe-i18n-msg msgid="l_confirmDetails" role="heading" aria-level="1"></oe-i18n-msg>
                </div>
            </div>
          </div>
          <template is="dom-if" if="{{!showAccountsList}}">
            <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px;border:2px solid #f6f8f9;border-radius: 5px;">
                <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;">
                    <div class="mdl-cell mdl-cell--12-col-desktop decline-text wrapClass1" role="cell">
                        {{getDeclineLabel()}}
                    </div>
                </div>
            </div>
          </template>
          <div class="listing-table-container margin-b-16" style="border:2px solid #f6f8f9;border-radius: 5px;">
            <div class="mdl-cell mdl-cell--12-col margin-32">
              <h1 class="pay_from ft-subtitle padding-b-16"><oe-i18n-msg msgid="b_transfersummary"></oe-i18n-msg></h1>                  
              <div class="mdl-cell mdl-cell--12-col horizontal layout layoutdiv margin-l-zero" style="flex-wrap: wrap">
                <template is="dom-if" if="{{responseObject.accountIdList.0.accountId}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_dbtAcntNumber"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.accountIdList.0.accountId}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.accountIdList.0.accountName}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_AccountName"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.accountIdList.0.accountName}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.accountIdList.0.accountCurrency.codeDescription}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_accountCurrency"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.accountIdList.0.accountCurrency.codeDescription}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.accountIdList.0.accountType.codeDescription}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_Accounttype"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.accountIdList.0.accountType.codeDescription}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.paymentConsent.reference}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_ReferenceId"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.paymentConsent.reference}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.paymentConsent.paymentType.codeDescription}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_TransferType"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.paymentConsent.paymentType.codeDescription}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.paymentConsent.creditorAccountId}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_BeneficiaryAcct"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                          {{responseObject.paymentConsent.creditorAccountId}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.paymentConsent.name}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="title-text">
                          <oe-i18n-msg msgid="l_Benefname"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                          {{responseObject.paymentConsent.name}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.paymentConsent.instructedAmount.amount}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_TransferAmt"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.paymentConsent.instructedAmount.currency}} {{responseObject.paymentConsent.instructedAmount.amount}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.paymentConsent.swiftCode}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_swiftCode"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.paymentConsent.swiftCode}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.paymentConsent.purposeCode}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_purposeCode"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{responseObject.paymentConsent.purposeCode.codeDescription}}
                      </div>
                  </div>
                </template>
                <template is="dom-if" if="{{responseObject.executionDate}}">
                  <div class="mdl-cell mdl-cell--6-col padding-b-16">
                      <span class="secondary-dark-text-s">
                          <oe-i18n-msg msgid="l_executionDate"></oe-i18n-msg>
                      </span>
                      <div class="primary-dark-text-m font-medium wordbreak-all">
                      {{formatDate(responseObject.executionDate)}}
                      </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="mdl-cell--12-col horizontal layout content-align-horizontal-end" tabindex="0" style="padding:4% 0px 10;">
            <div class="mdl-cell--3-col">
                <paper-button id="proceed" raised class="primary-medium-button" on-tap="callauthPage" style = "width:-webkit-fill-available;">
                    <oe-i18n-msg msgid="b_Submit"></oe-i18n-msg>
                </paper-button>
            </div>
          </div>
        </paper-card>
      </div>
    </div>
    `;
Polymer({
  is: 'open-banking-payment-consents-preview',
  _template: template,
  behaviors: [corpBehaviours.appCommonBehaviour, corpBehaviours.appMenuBehaviour, corpSbBehaviour.corpAuthAndWorkflow, sbBehaviours.paginationBehaviours],
  properties: {
    selectedPage: {
      type: String,
      notify: true
    },
    userId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    consentId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingConsentId');
      }
    },
    responseObject: {
      type: Object,
      notify: true
    },
    body: {
      type: Object,
      notify: true
    },
    authSuccess: {
      type: Boolean,
      notify: true,
      observer: '_setOchTxnId'
    },
    authSuccessObject: {
      type: Object,
      notify: true
    },
    previewDetails: {
      type: Object,
      notify: true
    },
    successResponse: {
      type: Array,
      notify: true
    },
    previewDetailsList: {
      type: Array,
      value: []
    },
    openBankingAccountsResponse: {
      type: Array,
      notify: true
    },
    successObj: {
      type: Object,
      notify: true
    },
    actionType: {
      type: String,
      notify: true,
      observer: "actionTypeChange"
    },
    showAccountsList: {
      type: Boolean,
      value: true
    },
    fromPreview: {
      type: Boolean,
      notify: true,
      value: false
    },
    infoMsgVatAmount: {
      type: String,
      value: getLabel('l_OpenBankingVATDisclaimer'),
      notify: true
    },
    infoMsgExchangeRate: {
      type: String,
      value: getLabel('l_OpenBankingexchangeRateDisclaimer'),
      notify: true
    }
  },
  _proceedToSuccessConsent() {
    this.userremarks = this.previewDetails.approverComment;
    var headervalue = {};
    if (this.previewDetails.displayAuthorization) {
      if (this.authenticationValidation(this.previewDetails.authMethods)) return;
      if (this.previewDetails.authMethods && this.previewDetails.authMethods.length == 1) {
        headervalue.primaryAccessCode = this.previewDetails.authMethods[0].wrapperValue;
      }
      if (this.previewDetails.authMethods && this.previewDetails.authMethods.length == 2) {
        headervalue.primaryAccessCode = this.previewDetails.authMethods[0].wrapperValue;
        headervalue.secondaryAccessCode = this.previewDetails.authMethods[1].wrapperValue;
      }
    }
    if (this.authSuccessObject != undefined) {
      headervalue.ochTransactionId = this.authSuccessObject.ochTransactionId;
      headervalue.authorizationMode = this.authSuccessObject.authorizationMode;
      if (this.authSuccessObject.softtokenotp) {
        headervalue.primaryAccessCode = this.authSuccessObject.softtokenotp;
      }
    }
    headervalue.acceptTermsAndConditions = 'Y';
    headervalue.workflowInput = {
      userRemarks: this.userremarks
    };
    var url = "/api/CBUsers/" + this.userId + "/customopenbanking-consent-request";
    var method = "POST";
    var transactionType = "OPC";
    var channelContextVal = undefined;
    this.submitNonFinancialDetails(url, method, this.body, headervalue, transactionType, channelContextVal);
  },
  _callSucessPage(event) {
    var tempSuccessObj = event;
    this.successResponse = event.detail.response;
    var responseHeader = JSON.parse(event.detail.xhr.getResponseHeader('channelcontext'));
    tempSuccessObj.chennelContext = responseHeader;
    this.successObj = tempSuccessObj;
    this.detailsTabEnabled = false;
    this.selectedPage = 3;
    this.authSuccess = false;
  },
  callauthPage() {
    this.selectedPage = 2;
    this.fromPreview = true;
  },
  _setOchTxnId() {
    if (this.authSuccess == true) {
      this._proceedToSuccessConsent();
    }
  },
  actionTypeChange() {
    if (this.actionType && this.actionType == "APPROVE") {
      this.showAccountsList = true;
    }
    else {
      this.showAccountsList = false;
    }
  },
  getDeclineLabel() {
    return getLabel("l_declinePaymentConsentText");
  },
  _errorHandler(event) {
    showAjaxError(event);
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  }
});
